import { defineTranslateKeys } from 'lib/tolgee'

const TOLGEE_KEYS = defineTranslateKeys({
  successfullyDeletedToast: ({ jobType, jobName }: { jobType: string; jobName: string }) => ({
    key: 'DeleteJobModal-successfullyDeletedToast',
    parameters: {
      jobType,
      jobName,
    },
    defaultValue: '{jobType} {jobName} foi excluído com sucesso!',
  }),
  modalTitle: ({ jobType }: { jobType: string }) => ({
    key: 'DeleteJobModal-title',
    parameters: {
      jobType,
    },
    defaultValue: 'Deseja excluir este {jobType}?',
  }),
  modalDescriptionLabel: ({ jobType }: { jobType: string }) => ({
    key: 'DeleteJobModal-descriptionLabel',
    parameters: {
      jobType,
    },
    defaultValue: 'Todo o conteúdo deste {jobType} será perdido e não será possível de ser recuperado',
  }),
})

export default TOLGEE_KEYS
